import React from 'react';
import createReactClass from 'create-react-class';
import { BrowserRouter } from 'react-router-dom';
import postal from 'postal';
import Routes from './Routes';
import MainMenu from './common/MainMenu';
import NotificationSystem from 'react-notification-system';
import LoginInfo from './common/User/LoginInfo';
import auth0 from '../helpers/auth0';
import RoleSelection from './RoleSelection';
import NeedsClaim from './common/NeedsClaim';
import request from '../helpers/request';
import appConfig from '../config/appConfig';

const Main = createReactClass({
  getInitialState() {
    const auth0Data = auth0.getTokenDataFromCache();

    return {
      viewTitle: '',
      userName: auth0Data.name,
      email: auth0Data.email,
      appVersion: ''
    };
  },

  componentWillMount() {
    var viewTitleChannel = postal.channel('viewTitle');
    this.viewTitleSubscription = viewTitleChannel.subscribe('viewtitle.change', data => {
      this.setState({
        viewTitle: data.viewTitle
      });
    });

    var notificationChannel = postal.channel('notification');
    this.notificationSubscription = notificationChannel.subscribe('notification.add', data => {
      if(this.notificationSystem) {
        this.notificationSystem.addNotification({
          title: 'Benachrichtigung',
          message: data.message,
          level: 'info'
        });
      }
    });

    var ajaxChannel = postal.channel('ajax');
    this.ajaxSubscription = ajaxChannel.subscribe('ajaxerror.add', data => {
      if(this.notificationSystem) {
        this.notificationSystem.addNotification({
          title: (data.title || 'Fehler'),
          message: data.message,
          level: 'error'
        });
      }
    });
    request.get({
      url: appConfig.apiUrl + 'appversion',
      success: data => {
        this.setState({
          appVersion: data
        })
      }
    })
  },

  componentDidMount() {

    // SmartAdmin theme initialization
    pageSetUp(); //eslint-disable-line no-undef
  },

  logout() {
    auth0.logout();
    window.location.reload();
  },

  render() {
    return (
      <BrowserRouter>
        <div>
          <header id="header">
              <div id="logo-group">

                  <span id="logo"> <img src="/images/logo.png" alt="Lagerverwaltung" /> </span>
              </div>

              <div className="pull-right">
                  <div id="hide-menu" className="btn-header pull-right">
                      <span> <a data-action="toggleMenu" title="Menü ein/ausblenden"><i className="fa fa-reorder"></i></a> </span>
                  </div>
              </div>
              <div className="btn-header pull-right" onClick={() => this.logout()}>
                <span>
                  <a title="Ausloggen"><i className="fa fa-sign-out"></i></a>
                </span>
              </div>
              <NeedsClaim claim="roles:override">
                <RoleSelection />
              </NeedsClaim>
          </header>

          <aside id="left-panel">
              <LoginInfo {...this.state} />

              <br />

              <MainMenu />

              <span className="minifyme" data-action="minifyMenu">
                  <i className="fa fa-arrow-circle-left hit"></i>
              </span>

          </aside>

          <div id="main" role="main">

              <div id="ribbon">

                  <ol className="breadcrumb">
                      <li>{this.state.viewTitle}</li>
                  </ol>
              </div>

              <NotificationSystem ref={c => this.notificationSystem = c} />
              <Routes />
          </div>

          <div className="page-footer" style={{display: 'flex', justifyContent: 'space-between'}}>
            <span className="txt-color-white">
              <strong>Version:</strong> {this.state.appVersion}
            </span>
            <a href="http://www.softwarepark.cc">
              <span className="txt-color-white">Softwarepark Services GmbH © {new Date().getFullYear()}</span>
            </a>
          </div>
        </div>
      </BrowserRouter>
    );
  }
});

export default Main;



// WEBPACK FOOTER //
// ./src/components/Main.js